import { render, staticRenderFns } from "./MonthlySalesPlanBarChart.vue?vue&type=template&id=ddbc42f2&"
import script from "./MonthlySalesPlanBarChart.vue?vue&type=script&lang=js&"
export * from "./MonthlySalesPlanBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VSimpleTable})
